// import { ReactComponent as GPT } from '../../../assets/etc-icons/icon_gpt_model.svg';

export type AIModels = Record<string, AIModel>;

export interface AIModelAPI {
  model: AIModelName;
  displayName: string;
  description: string;
  isAvailable: boolean;
  vendor: string;
  profileUrl: string;
  usage: IUsage;
  isDefault: boolean;
}

export interface AIModel {
  model: string;
  displayName: string;
  description: string;
  isAvailable: boolean;
  vendor: string;
  usage?: IUsage;
  profileUrl: string;
  isDefault: boolean;
  tags?: string[];
  // icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export enum AIModelName {
  GPT_3_5 = 'GPT-3.5',
  GPT_4 = 'GPT-4',
  GPT_4O = 'GPT-4o',
  GPT_4O_Mini = 'GPT-4o-mini',
  GPT_4_1 = 'GPT-4.1',
  GPT_5 = 'GPT-5',
  GPT_5_4 = 'GPT-5.4',
  GPT_5_4_mini = 'GPT-5.4-mini',
  GPT_5_4_nano = 'GPT_5.4-nano',
  GPT_5_5 = 'GPT-5.5',
  GPT_5_6_Sol  = 'GPT-5.6 Sol',
  GPT_5_6_Terra = 'GPT-5.6 Terra',
  GPT_5_6_Luna = 'GPT-5.6 Luna'
}

export interface AIModelsState {
  models: AIModels;
  selectedModel: AIModel;
}

export const initialState: AIModelsState = {
  models: {},
  selectedModel: {
    model: AIModelName.GPT_5_6_Luna,
    description: '더 많은 내용을 질문할 수 있어요.',
    displayName: '빠른 작업',
    isAvailable: true,
    vendor: 'AzureOpenAI',
    profileUrl: '/assets/etc-icons/icon_gpt_model.svg',
    isDefault: true,
    usage: {
      modelName: AIModelName.GPT_5_6_Luna,
      totalCount: 10,
      remainCount: 10,
      useCount: 0,
    },
  },
};

export const AIModels: AIModel[] = [
  {
    model: AIModelName.GPT_5_6_Luna,
    description: '빠른 응답에 최적화되어 있어요.',
    displayName: '빠른 작업',
    isAvailable: true,
    vendor: 'AzureOpenAI',
    profileUrl: '/assets/etc-icons/icon_gpt_model.svg',
    isDefault: true,
    usage: {
      modelName: AIModelName.GPT_5_6_Luna,
      totalCount: 10,
      remainCount: 10,
      useCount: 0,
    },
  },
  {
    model: AIModelName.GPT_5_6_Sol,
    description: '깊이 있는 대화와 정교한 작업에 적합해요.',
    displayName: '고급 작업',
    isAvailable: true,
    vendor: 'AzureOpenAI',
    profileUrl: '/assets/etc-icons/icon_gpt_model.svg',
    isDefault: true,
    usage: {
      modelName: AIModelName.GPT_5_6_Sol,
      totalCount: 10,
      remainCount: 10,
      useCount: 0,
    },
  },
  {
    model: AIModelName.GPT_5_6_Terra,
    description: '일상적인 작업에 적합해요.',
    displayName: '표준 작업',
    isAvailable: true,
    vendor: 'AzureOpenAI',
    profileUrl: '/assets/etc-icons/icon_gpt_model.svg',
    isDefault: true,
    usage: {
      modelName: AIModelName.GPT_5_6_Terra,
      totalCount: 10,
      remainCount: 10,
      useCount: 0,
    },
  }

];

export interface IUsage {
  userId?: string;
  modelName: string;
  totalCount?: number;
  useCount: number;
  remainCount?: number;
  date?: string;
}
